import { Component, OnInit, HostListener } from '@angular/core';
import { HomeService } from '../../services/home.service';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { SharedConsts } from 'src/app/shared/constants';

@Component({
  selector: 'app-sub-banner',
  templateUrl: './sub-banner.component.html',
  styleUrls: ['./sub-banner.component.scss'],
  standalone: false,
})
export class SubBannerComponent implements OnInit {
  gamificationBanner: any = [];
  slidesMobile = [];
  slides = []
  environment = {...environment};
  slideConfig = {
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: true,
    loop: true,
    autoplay: {
      delay: 2000,
    },
    pauseOnHover: false,
    pauseOnFocus: false,
    responsive: [
      { breakpoint: 1700, settings: { slidesToShow: 3, slidesToScroll: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 767, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };
  constructor(private homeService: HomeService, public statePersist: StatePersistService,
    private router: Router, private googleAnalyticsService: GoogleAnalyticsService) {}

  ngOnInit() {
    // this.getGamificationBanner()
    this.getHomeBanners()
  }

  getGamificationBanner() {
    this.homeService.getGamificationBanner()
    .subscribe(
      data => {
        if (data.response) {
          this.gamificationBanner = data.response
          this.getHomeBanners()
        }
      }
    );
  }
  getHomeBanners() {
    this.homeService.subBanners()
    .subscribe(
      data => {
        if (data.response) {
          let images_array = [];
          let mobile_array = [];
          if (this.gamificationBanner.length > 0){
            let obj = this.gamificationBanner[0]
            for (let i = 0; i < data.response.sub_banners.length; i++) {
              if ((obj.sequence > 1 && obj.sequence <= data.response.top_banner_new.length && obj.sequence-1 == i) || ((obj.sequence == 0 || obj.sequence == 1) && i == 0)){
                let new_obj = {"banner_sequence":obj.sequence,"banner_url":"","search_value":"","brand_filter":"","web_image_url":obj.bannerImageWebsite,"mob_image_url":obj.bannerImageMobile, 'gamification_banner':true, 'category_title':obj.category_title}
                images_array.push(new_obj)
                mobile_array.push(new_obj)
              }
              images_array.push(data.response.sub_banners[i])
              mobile_array.push(data.response.sub_banners[i])
            }
            if (obj.sequence > data.response.sub_banners.length){
              let new_obj = {"banner_sequence":obj.sequence,"banner_url":"","search_value":"","brand_filter":"","web_image_url":obj.bannerImageWebsite,"mob_image_url":obj.bannerImageMobile, 'category_title':obj.category_title}
              images_array.push(new_obj)
              mobile_array.push(new_obj)
            }
            this.statePersist.setLocalStorage('orderCompleteBannerImage', {'bannerOrderCompleteImageWebsite':obj.bannerOrderCompleteImageWebsite})
          }
          else{
            for (let i = 0; i < data.response.sub_banners.length; i++) {
              images_array.push(data.response.sub_banners[i])
              mobile_array.push(data.response.sub_banners[i])
            }
            this.statePersist.setLocalStorage('orderCompleteBannerImage', {'bannerOrderCompleteImageWebsite':''})
          }
          
          this.slidesMobile = mobile_array
          this.slides = images_array

        }
      }
    );
  }

  redirectTo(obj){
    let url, thirdpart_url='';
    const envUrl = environment.cmsNavigationUrl;
    
    this.googleAnalyticsService.eventEmitter(SharedConsts.HOME_BANNER_SELECTED_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.HOME_BANNER_SELECTED_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);

    if  (obj.search_value && obj.search_value != ''){
      this.statePersist.setLocalStorage('product_data', {'search_keyword':obj.search_value, 'category_title':obj.category_title}, 'search')
      url = 'product/listing/All'
      thirdpart_url = ''
    }
    else if (obj.brand_filter && obj.brand_filter != ''){
      this.statePersist.setLocalStorage('product_data', {'brand_filter':obj.brand_filter,'category_title':''})
      url = 'product/listing/All'
      thirdpart_url = ''
    }
    else{
      if (obj.banner_url.includes('product')){
        url = obj.banner_url.split(envUrl)[1];
        this.statePersist.setLocalStorage('product_data', {'brand_filter':''});
        thirdpart_url = ''
      }
      else{
        thirdpart_url = obj.banner_url;
        this.statePersist.setLocalStorage('product_data', {'brand_filter':''});
        url = ''
      }
    }
    
    if (!obj.gamification_banner && thirdpart_url == ''){
      this.router.navigate([url]);
    }
    else if(!obj.gamification_banner && thirdpart_url != ''){
      window.open( 
        thirdpart_url, "_blank");
     }
  }
}
